import {values} from 'ramda';

import {isFilterValueActive} from '../../utils/isFilterValueActive';
import {EagGridState, selectFilterValuesWithoutStaticFilters} from '../createEagGridStore';
import {useEagGridSelector} from '../useEagGridSelector';

/**
 * Returns the number of active filters excluding any static filters
 * injected by the host via queryModifier.
 *
 * Uses the same predicate as useIsFilterActive so the badge count is
 * always consistent with the filter-active highlight on the icon button.
 */
const selectActiveFilterCount = (state: EagGridState): number =>
  values(selectFilterValuesWithoutStaticFilters(state)).filter(isFilterValueActive).length;

export function useActiveFilterCount(): number {
  return useEagGridSelector(selectActiveFilterCount);
}
